import { ChakraProvider } from '@chakra-ui/react';
import React from 'react';
import { QueryClientProvider } from 'react-query';
import { BrowserRouter as Router } from 'react-router-dom';

import { ReactQueryDevtools } from 'react-query/devtools';

import AppProvider from './hooks';

import Routes from './routes';

import { queryClient } from './services/queryClient';
import { theme } from './styles/theme';

import './styles/global.css';

const App: React.FC = () => (
  <QueryClientProvider client={queryClient}>
    <ChakraProvider theme={theme}>
      <Router>
        <AppProvider>
          <Routes />
        </AppProvider>
      </Router>
    </ChakraProvider>

    <ReactQueryDevtools />
  </QueryClientProvider>
);

export default App;
